<template>
    <div v-if="collection.models.length">
        <b-table
            :items="collection.models"
            :fields="table.fields"
            :per-page="table.per_page"
            :current-page="table.current_page"
            id="batch-recieve-server-table"
            responsive
        >
            <template #cell(select)="data">
                <RecieveSampleCheckbox
                    @removingSample="handleRemove"
                    @addingSample="handleUpdate"
                    :row="data.item"
                    :rowDetails="recieved_items"
                />
            </template>
            <template #cell(pid)="data">
                <a :href="`#/samples/${data.item.id}`" class="btn-link">
                    {{ data.item.publicNumber() }}
                </a>
            </template>
            <template #cell(submission.pid)="data">
                <existence-gate :entity="data.item" :levels="['submission']" :field="'pid'">
                    <template #existing-content>
                        <router-link :to="`/submissions/${getData(data.item, {
                                levels: ['submission'],
                                field: 'id',
                            })}`">
                            {{ data.item.getSubmission().publicNumber() }}
                        </router-link>
                    </template>
                </existence-gate>
            </template>
            <template #cell(created_at)="data">
                {{ data.item | moment("L") }}
            </template>
        </b-table>
        <custom-table-pagination
            :options="table.per_page_options"
            :current_page="table.current_page"
            :per_page="table.per_page"
            :total_rows="collection.models.length"
            @update="updatePaginationData"
            table_id="batch-recieve-server-table"
            selector_prefix="Samples per page"
        />
    </div>
</template>
<script>
import ExistenceGate from "@/components/shared/ExistenceGate";
import { getEntityData } from "@/shared/utils";
import RecieveSampleCheckbox from "@/components/lab/sample/form/RecieveSampleCheckbox"
import CustomTablePagination from "@/components/shared/CustomTablePagination";

export default {
    name: "BatchRecieveServerTable",
    components: {
        ExistenceGate,
        RecieveSampleCheckbox,
        CustomTablePagination,
    },
    props: {
        receiveList: {
            default: () => []
        },
        collection: {
            default: () => null
        },
    },
    data() {
        return {
            recieved_items: [],
            table: {
                fields: [
                    { key: "select", label: "Sel." },
                    { key: "pid", label: "#." },
                    { key: "submission.pid", label: "Submission." },
                    { key: "submission.project.customer.full_name", label: "Customer." },
                    { key: "created_at", label: "Created." },
                ],
                per_page: 15,
                current_page: 1,
                per_page_options: [15, 25, 50]
            },
        };
    },
    methods: {
        getData({ _reference }, data) {
            return getEntityData({
                entity: _reference,
                ...data,
            });
        },
        handleUpdate(row) {
            this.recieved_items.push(row);
        },
        handleRemove(index) {
            this.recieved_items.splice(index, 1);
        },
        updatePaginationData({ field, value }) {
            this.table[field] = value;
        },
    },
    watch: {
        recieved_items: {
            handler() {
                this.$emit("itemsListUpdated", this.recieved_items);
            },
            deep: true,
            immediate: true,
        }
    },
    mounted() {
        // if there are no projects go back to the main page
        if (!this.receiveList.length) {
            this.$router.back()
        }
    }
}
</script>